// extracted by mini-css-extract-plugin
export default {"tx":"_53051ebba0","line":"_721515dab1"};